import { ProfileBanner } from '@/app/components/ProfileBanner';
import { ContentHubMenu } from '@/cmsComponents/ContentHubMenu';
import LandingHeaderV2 from '@/modules/LandingHeaderV2';
import { IArticleCategorySummary } from '@/types/cms';
import dynamic from 'next/dynamic';
import React from 'react';

import Container from '@material-ui/core/Container';

import Footer from 'modules/Footer';

// import LandingHeader from 'modules/LandingHeader';
import styles from './style.module.scss';

const CookieConsentPrompt = dynamic(() => import('@/app/components/CookieConsentPrompt'));

type ContentHubContainerProps = {
  categories: IArticleCategorySummary[];
  selectedCategorySlug?: string | null;
  children: React.ReactChild | React.ReactFragment | React.ReactPortal | boolean;
};

export const ContentHubContainer = ({
  categories,
  selectedCategorySlug = null,
  children,
}: ContentHubContainerProps) => {
  return (
    <div className={styles.container}>
      {/* <LandingHeader /> */}
      <LandingHeaderV2 />
      <ContentHubMenu categories={categories} selectedCategorySlug={selectedCategorySlug} />
      <Container maxWidth="md">{children}</Container>
      <Footer />
      <CookieConsentPrompt />
      <ProfileBanner />
    </div>
  );
};
